import {useMemo} from 'react'
import {camelizeKeys} from 'humps'
import {useTranslation} from 'react-i18next'
import useSWRImmutable from 'swr/immutable'
import {useNavigate, useParams} from 'react-router'

import {useRails} from '~/react/contexts/rails'
import Loading from '~/react/components/Loading'
import {fetcher} from '~/api'
import {replaceMoneyWithDineroObject} from '~/api/serializer'
import {PaymentWizard} from '../../components/PaymentWizard'
import FullScreenModalLayout from '../../../../../../app/javascript/react/layouts/FullScreenModalLayout'

const PayBillScreen = () => {
  const {t} = useTranslation('pointsOnPayments')
  const navigate = useNavigate()
  const onClose = () => {
    // Check if there is more than one entry in the browser history
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      // Fallback to the bills table if no internal history exists
      navigate('/points_on_payments/bills', {replace: true})
    }
  }
  const {currentSupplier} = useRails()
  const {payableId} = useParams()

  const creatingNewPayable = payableId === 'new'

  const {
    data: payable,
    mutate,
    isLoading,
  } = useSWRImmutable(
    !creatingNewPayable
      ? `/points_on_payments/api/suppliers/${currentSupplier.id}/bills/${payableId}`
      : null,
    fetcher,
    {
      suspense: true,
    },
  )

  const monetizedPayable = useMemo(() => {
    if (!payable) return null

    return replaceMoneyWithDineroObject(camelizeKeys(payable, {deep: true}))
  }, [payable])

  return (
    <Loading>
      <FullScreenModalLayout
        title={t('pointsOnPayments:payBillScreen.title')}
        onClose={onClose}
      >
        <PaymentWizard
          payable={monetizedPayable}
          reloadPayable={mutate}
          isLoading={!creatingNewPayable && isLoading}
        />
      </FullScreenModalLayout>
    </Loading>
  )
}

export default PayBillScreen
